import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Content from "./components/Content";
import Home from "./pages/Home";
import AreaBiodiversity from "./pages/AreaBiodiversity";
import TutupanLahan from "./pages/TutupanLahan";
import JenisFauna from "./pages/JenisFauna";
import JenisFlora from "./pages/JenisFlora";
import BiodiversityFlora from "./pages/BiodiversityFlora";
import BiodiversityFauna from "./pages/BiodiversityFauna";
import PublikasiFile from "./pages/PublikasiFile";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app-container">
        <Sidebar />
        <Content>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/area-biodiversity" element={<AreaBiodiversity />} />
            <Route path="/tutupan-lahan" element={<TutupanLahan />} />
            <Route path="/jenis-fauna" element={<JenisFauna />} />
            <Route path="/jenis-flora" element={<JenisFlora />} />
            <Route path="/biodiversity-flora" element={<BiodiversityFlora />} />
            <Route path="/biodiversity-fauna" element={<BiodiversityFauna />} />
            <Route path="/publikasi-file" element={<PublikasiFile />} />
          </Routes>
        </Content>
      </div>
    </Router>
  );
}

export default App;
